import { useEffect, useState, useSyncExternalStore } from 'react'
import { getActivity, subscribeActivity } from './requestActivity'
import './feedback.css'

export function LoadingState({ label = '데이터를 불러오는 중', rows = 3, fullPage = false, compact = false }) {
  return <div className={`console-loading${fullPage ? ' is-full-page' : ''}${compact ? ' is-compact' : ''}`} role="status" aria-live="polite">
    <div className="console-loading-heading"><span className="console-spinner" aria-hidden="true"/><span>{label}</span></div>
    {!compact && <div className="console-skeleton" aria-hidden="true">{Array.from({ length: rows }, (_, i) =>
      <div className="console-skeleton-row" key={i}><i/><span><b/><b/></span><em/></div>)}</div>}
  </div>
}

export function RequestActivity() {
  const activity = useSyncExternalStore(subscribeActivity, getActivity, getActivity)
  const [visible, setVisible] = useState(false), [slow, setSlow] = useState(false)
  const pending = activity.count > 0
  useEffect(() => {
    if (!pending) { setVisible(false); setSlow(false); return undefined }
    const show = setTimeout(() => setVisible(true), 250)
    const explain = setTimeout(() => setSlow(true), Math.max(0, 10000 - (Date.now() - activity.startedAt)))
    return () => { clearTimeout(show); clearTimeout(explain) }
  }, [pending, activity.startedAt])
  const message = activity.mutations ? '변경 요청의 서버 응답을 기다리고 있습니다' : '최신 데이터를 확인하고 있습니다'
  return <div className={'console-request-activity' + (visible && pending ? ' is-active' : '')} aria-hidden={!visible || !pending}>
    <div className="console-request-line" aria-hidden="true"><i/></div>
    {visible && pending && <div className="console-request-label" role="status" aria-live="polite">
      <span className="console-spinner" aria-hidden="true"/>{slow ? '응답이 늦어지고 있습니다. 연결 상태를 확인하고 있어요.' : message}
    </div>}
  </div>
}

export function AsyncFeedback({ busy, error, onRetry, label = '조회 중', initial = false }) {
  if (busy) return <LoadingState label={label} compact={!initial}/>
  if (!error) return null
  return <div className="console-retry" role="alert"><span>{error}</span>{onRetry && <button type="button" onClick={onRetry}>다시 조회</button>}</div>
}
